<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="按问卷筛选" prop="questionnaireId">
                <questionnaire v-model="query.questionnaireId"></questionnaire>
            </el-form-item>
        </template>
        <template slot="btns">
            <el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
                新增路径
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="路径名称" align="center" prop="name" />
            <el-table-column label="关联问卷" align="center" prop="questionnaireName" />
            <el-table-column label="创建时间" align="center" prop="createTime">
                <template slot-scope="{ row }">
                    {{ formatDate(row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="140">
                <template slot-scope="{ row }">
                    <el-link style="margin-right: 10px" :underline="false" type="primary" @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link :underline="false" type="danger" @click="handleDel(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/path";
import listMixin from '@/mixins/list';
import questionnaire from "@/components/questionnaire.vue";
export default {
    components: { questionnaire },
    data() {
        return {
            // 查询参数
            query: {
                word: "",
                siteId: "",
                type: ""
            },
            countries: []
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query
            };
            page(params).then(({ code, data, message }) => {
                if (code == 200) {
                    this.tableData = data.records;
                    this.total = data.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push("/path/form");
        },
        handleEdit(row) {
            this.$router.push({ path: "/path/form", query: { id: row.id } });
        },
        handleDel(row) {
            this.$confirm("是否删除该路径配置?", "提示", {
                type: "warning",
            })
                .then(() => {
                    del(row.id).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("删除成功");
                            this.search();
                        } else {
                            this.$message.error(message);
                        }
                    });
                })
                .catch(() => { });
        },
    },
};
</script>